'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:back');
}

var _invoke = require('../invoke');

/**
 * 后退
 *
 * TODO: ANDROID 旧版实现有问题
 *
 * 支持版本
 * + iHotel/?
 *
 * @memberof webview
 * @static
 * @name back
 * @return {Undefined}
 * @example
 *  hbnb.webview.back();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('called');
    }

    _invoke('webview', 'back');
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/webview/back.js
// module id = 140
// module chunks = 0 8 9